import { TranslationType } from "../types";
import { dashboard } from "./en/dashboard";
import { landing } from "./en/landing";
import { story } from "./en/story";
import { common } from "./en/common";
import { settings } from "./en/settings";
import { auth } from "./en/auth";
import { profile } from "./en/profile";
import { errors } from "./en/errors";

export const en: TranslationType = {
  ...dashboard,
  ...landing,
  ...story,
  ...common,
  ...settings,
  ...auth,
  ...profile,
  ...errors
};
